module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_troms_og_finnmark_pos.55c3431c.pdf";